<template lang="pug">
  b-container(fluid="fluid")
    b-row
      b-col
        //- ご契約者情報
        h5#customer-info.font-weight-bold.ml-3 ご契約者情報
        b-form-group.align-content(v-for="(field, key) of fields[0]", label-cols="3", label-align="right", :key="key", label-size="sm", :label="field", :label-class="data[key].label_class")
          b-form-input.mb-2(v-if="field !== '会社・組織所在地' && field !== '会社名・組織名' && field !== '住所' && field !== '郵便番号'", size="sm", :type="data[key].type", v-model="value[key]", :placeholder="data[key].placeholder", :class="data[key].form_class", :state="data[key].error_msg_list.length === 0 ? null : false")
          b-form-select(v-if="field === '会社・組織所在地'", size="sm", v-model="value[key]", :options="prefectures", @change="updateCompanyNameSearch")
          b-form-input.mb-2(v-if="field === '会社名・組織名'", @input="updateCompanyNameSearch", size="sm", :type="data[key].type", v-model="value[key]", :placeholder="data[key].placeholder", :class="data[key].form_class", :state="data[key].error_msg_list.length === 0 ? null : false")
          div(v-if="field === '会社名・組織名'")
            CompanyNameSearch.mb-3(v-if="bShowCompanyNameList", :isCompanyListLoading="isCompanyListLoading", :company_list="company_list", @select="setCompanyName")
          p.mb-2(v-if="field === '会社名・組織名'") ※会社名を入力すると候補が表示されます。その中から御社名を選択ください。
          b-form-checkbox(v-model="value.foreign_company_flg", v-if="field === '会社名・組織名'", size="sm", style="margin-top: -9px;") 外国法人に該当します
          .form-inline(v-if="field === '郵便番号'")
            b-form-input.mb-2(v-if="field === '郵便番号'", size="sm", :type="data[key].type", v-model="value[key]", :placeholder="data[key].placeholder", :class="data[key].form_class", :state="data[key].error_msg_list.length === 0 ? null : false")
            zip-cloud(:zip_code="value['postal_code']", :prefecture.sync="value['prefecture']", :city.sync="value['city']", :address1.sync="value['address1']", :error_msg.sync="get_address_error")
          b-form-text.mb-2.error-message-color(v-if="field === '郵便番号'", style="margin-top: -5px;") {{get_address_error}}
          div(v-if="field === '住所'")
            b-form-group.align-content(v-for="(field2, key2) of fields[1]", label-cols="3", label-align="right", :key="key2", label-size="sm", :label="field2", :label-class="data[key2].label_class")
              b-form-text.mb-2.mail-text(v-if="field2 === '都道府県'") {{value.prefecture}}
              b-form-input.mb-2(v-else, size="sm", :type="data[key2].type", v-model="value[key2]", :placeholder="data[key2].placeholder", :class="data[key2].form_class", :state="data[key2].error_msg_list.length === 0 ? null : false")
              b-form-text.align-left.text-left.error-message-color.mb-2(v-for="(error_msg) of data[key2].error_msg_list") {{error_msg}}
          b-form-text.align-left.text-left.error-message-color.mb-2(v-for="(error_msg) of data[key].error_msg_list") {{error_msg}}
        b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", label="E-mail", label-class="py-05 mb-4 none-label")
          b-form-text.mb-2.mail-text {{data.bill_e_mail.value}}
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
        //- ご契約種別・お支払い方法
        h5#contract-type.font-weight-bold.ml-3 ご契約種別・お支払い方法
        b-form-group.align-content(v-for="(field, key) of fields[2]", label-cols="3", label-align="right", :key="key", label-size="sm", :label="field", :label-class="data[key].label_class")
          b-form-radio-group(v-if="data[key].type === 'radio'", v-model="value[key]", :stacked="true")
            b-form-radio.mb-1(v-for="(option, key) of data[key].options", :value="option.value") {{option.text}}
          b-form-input.mb-2(v-else, size="sm", :type="data[key].type", v-model="value[key]")
          b-form-text.align-left.text-left.error-message-color.mb-2(v-for="(error_msg) of data[key].error_msg_list") {{error_msg}}
        b-form-text.ml-5 ※月払いの場合の最低契約月数は1カ月となります。
        b-form-text.ml-5 ※銀行振込を選択される場合、振り込み手数料はお客さま負担となります。あらかじめご了承願います。
        b-form-text.ml-5 ※口座振替を選択される場合、お申込みから最短で翌々月の請求分より対応可能です。
        b-form-text.ml-5 ※クレジット決済を選択される場合、サービス開通のタイミングでカード情報登録のメールを案内させていただきます。
        b-form-text.ml-5 &nbsp;&nbsp;&nbsp;&nbsp;必ず、有効期限内でのご登録をお願いいたします。
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
        //- 請求書宛名情報
        h5#send-invoice.font-weight-bold.ml-3
          .form-inline
            b-form-checkbox(v-model="value.send_invoice", @change="toggleSendInvoice") 請求書宛名情報
            b-form-text.ml-2(style="font-size: 13px;") ※ご契約者情報と異なる箇所のみご記入ください
        b-collapse#collapse-invoice(v-model="SendInvoiceIsOpen")
          b-form-group.align-content(v-for="(field, key) of fields[3]", label-cols="3", label-align="right", :key="key", label-size="sm", :label="field", :label-class="data[key].label_class")
            b-form-input.mb-2(v-if="field !== '住所' && field !== '郵便番号'", size="sm", :type="data[key].type", v-model="value[key]", :placeholder="data[key].placeholder", :class="data[key].form_class", :state="data[key].error_msg_list.length === 0 ? null : false")
            .form-inline(v-if="field === '郵便番号'")
              b-form-input.mb-2(v-if="field === '郵便番号'", size="sm", :type="data[key].type", v-model="value[key]", :placeholder="data[key].placeholder", :class="data[key].form_class", :state="data[key].error_msg_list.length === 0 ? null : false")
              zip-cloud(:zip_code="value['bill_postal_code']", :prefecture.sync="value['bill_prefecture']", :city.sync="value['bill_city']", :address1.sync="value['bill_address1']", :error_msg.sync="get_send_address_error")
            b-form-text.mb-2.error-message-color(v-if="field === '郵便番号'", style="margin-top: -5px;") {{get_send_address_error}}
            div(v-if="field === '住所'")
              b-form-group.align-content(v-for="(field2, key2) of fields[4]", label-cols="3", label-align="right", :key="key2", label-size="sm", :label="field2", :label-class="data[key2].label_class")
                //.form-inline
                b-form-input.mb-2(size="sm", :type="data[key2].type", v-model="value[key2]", :placeholder="data[key2].placeholder", :class="data[key2].form_class", :state="data[key2].error_msg_list.length === 0 ? null : false")
                b-form-text.align-left.text-left.error-message-color.mb-2(v-for="(error_msg) of data[key2].error_msg_list") {{error_msg}}
            b-form-text.align-left.text-left.error-message-color.mb-2(v-for="(error_msg) of data[key].error_msg_list") {{error_msg}}
        //- 空行
        b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
        //- クラウド版サポートサイトご利用時のパスワード
        h5#password.font-weight-bold.ml-3 クラウド版サポートサイトご利用時のパスワード
        b-form-group.align-content(v-for="(field, key) of fields[5]", label-cols="3", label-align="right", :key="key", label-size="sm", :label="field", :label-class="data[key].label_class")
          b-form-input(size="sm", :type="data[key].type", v-model="value[key]", :placeholder="data[key].placeholder", :class="data[key].form_class", :state="data[key].error_msg_list.length === 0 ? null : false")
          b-form-text.align-left.text-left.mb-2(v-if="key === 'password'") ※大文字・小文字・数字・記号から、少なくとも2種類を含む文字列にしてください。
          b-form-text.align-left.text-left.error-message-color.mb-2(v-for="(error_msg) of data[key].error_msg_list") {{error_msg}}
    b-button.float-right.mr-5.my-3(pill, variant="outline-primary", size="lg", @click="inputCheck", :disabled="isLoading")
      .float-left.search_message.mr-1.font-weight-bold 次へ
      b-icon.float-right.next-icon(icon="arrow-right-circle")
</template>

<script>
/* eslint-disable */
import Api from "@/repositories/api"
import ZipCloud from "@/components/ZipCloud";
import CompanyNameSearch from "@/components/CompanyNameSearch.vue";

const LbcCode = Api.get("lbcCode");
const F201FirstOrderRepository = Api.get("f201FirstOrder");

export default {
  name: "InputCustomerData",
  props: {
    value: { type: Object, required: false }
  },
  components: {
    ZipCloud,
    CompanyNameSearch
  },
  // アンカーに選択されている箇所を開く(DOM作成前に実行)
  created () {
    // アンカーを取得
    const anchor = this.$route.hash;

    // 請求書宛名情報の場合
    if (anchor === "#send-invoice") {
      // チェックボックスにチェックを付ける
      this.value.send_invoice = true;

      // 請求書宛名情報を開く
      this.SendInvoiceIsOpen = true;
    }

    // 仮申し込みメールアドレスを取得する
    this.data.bill_e_mail.value = this.value.e_mail

    // お客様情報入力画面に戻ってきたとき、請求書宛名情報にチェックがついている場合
    if (this.value.send_invoice === true) {
      // 請求書宛名情報を開く
      this.SendInvoiceIsOpen = true;
    }
  },
  // アンカーまでスクロールさせる(DOM作成後に実行)
  mounted() {
    // ハッシュ値を取得
    const hash = this.$route.hash;

    // アンカーのハッシュがある場合
    if (hash && hash.match(/^#.+$/)) {
      // 対象のIDまでスクロール
      document.getElementById(this.$route.hash.replace(/^#/, '')).scrollIntoView();
    }
  },
  data() {
    // 必須のラベル
    const require_label_class = "py-05 mb-4 required-label-after";

    // 任意のラベル
    const elective_label_class = "py-05 mb-4 elective-label-after";

    // 必須・任意のラベルなし
    const none_label_class = "py-05 mb-0 none-label";

    return {
      bShowCompanyNameList: false,
      isCompanyListLoading: false,
      SendInvoiceIsOpen: false,
      sen_invoice: false,
      fields: [
        {
          // ご契約者情報
          prefecture: "会社・組織所在地",
          company_name: "会社名・組織名",
          company_kana: "会社名・組織名(かな)",
          president_name: "代表者名",
          president_kana: "代表者名(かな)",
          department: "部署名",
          person_name: "担当者名",
          person_kana: "担当者名(かな)",
          postal_code: "郵便番号",
          address : "住所",
          phone_number: "電話番号",
          fax_number : "FAX番号",
        },
        {
          // 住所
          prefecture : "都道府県",
          city : "市区町村",
          address1 : "丁目番地",
          address2 : "建物名以下",
        },
        {
          // ご契約種別・お支払い方法
          contract_type: "ご契約種別",
          payment_method: "お支払い方法"
        },
        {
          // 請求書宛名情報
          bill_company_name: "会社名・組織名",
          bill_company_kana: "会社名・組織名(かな)",
          bill_department: "部署名",
          bill_president_name: "担当者名",
          bill_president_kana: "担当者名(かな)",
          bill_postal_code: "郵便番号",
          bill_address: "住所",
          bill_phone_number: "電話番号",
          bill_fax_number: "FAX番号",
          bill_e_mail: "E-mail",
          re_bill_e_mail: "E-mail(確認用)",
        },
        {
          // 請求書宛名情報の住所
          bill_prefecture: "都道府県",
          bill_city: "市区町村",
          bill_address1: "丁目番地",
          bill_address2: "建物名以下"
        },
        {
          // パスワード
          password: "パスワード",
          re_password: "パスワード(確認用)",
        }
      ],
      data: {
        /* ご契約者情報 */
        // 会社名・組織名
        company_name: { type: "text", placeholder: "株式会社ネオジャパン", value: "", label_class: require_label_class, error_msg_list: [] },
        // 会社名・組織名(かな)
        company_kana: { type: "text", placeholder: "かぶしきがいしゃねおじゃぱん", value: "", label_class: require_label_class, error_msg_list: [] },
        // 代表者名
        president_name: { type: "text", placeholder: "山田　太郎", value: "", label_class: require_label_class, error_msg_list: [] },
        // 代表者名(かな)
        president_kana: { type: "text", placeholder: "やまだ　たろう", value: "", label_class: require_label_class, error_msg_list: [] },
        // 部署名
        department: { type: "text", placeholder: "営業部", value: "", label_class: require_label_class, error_msg_list: [] },
        // 担当者名
        person_name: { type: "text", placeholder: "山田　太郎", value: "", label_class: require_label_class, error_msg_list: [] },
        // 担当者名(かな)
        person_kana: { type: "text", placeholder: "やまだ　たろう", value: "", label_class: require_label_class, error_msg_list: [] },
        // 郵便番号
        postal_code: { type: "text", placeholder: "2208110（半角数字）", value: "", form_class: "number-form add-text", label_class: require_label_class, error_msg_list: [] },
        // 住所
        address: { type: "", label_class: none_label_class },
        // 都道府県
        prefecture: { type: "text", placeholder: "神奈川県", value: "", form_class: "w-50", error_msg_list: [], label_class: require_label_class },
        // 市区町村
        city: { type: "text", placeholder: "横浜市西区", value: "", form_class: "w-50", error_msg_list: [], label_class: require_label_class },
        // 丁目番地
        address1: { type: "text", placeholder: "みなとみらい二丁目2-1", value: "", form_class: "w-75", error_msg_list: [], label_class: require_label_class },
        // 建物名以下
        address2: { type: "text", placeholder: "", value: "", form_class: "w-75", error_msg_list: [], label_class: elective_label_class },

        // 電話番号
        phone_number: { type: "text", placeholder: "045-123-1234（半角数字）", value: "", form_class: "number-form", label_class: require_label_class, error_msg_list: [] },
        // FAX番号
        fax_number: { type: "text", placeholder: "045-123-1234（半角数字）", value: "", form_class: "number-form", label_class: elective_label_class, error_msg_list: [] },

        // ご契約種別
        contract_type: {
          type: "radio",
          options: [
            { value: 0, text: "月払い" },
            { value: 1, text: "年間一括払い" },
          ],
          value: 0,
          label_class: require_label_class,
          error_msg_list: []
        },
        // お支払い方法
        payment_method: {
          type: "radio",
          options: [
            { value: 0, text: "銀行振込" },
            { value: 1, text: "口座振替" },
            { value: 2, text: "クレジットカード決済" }
          ],
          value: 0,
          label_class: require_label_class,
          error_msg_list: []
        },

        // 請求書宛名情報
        // 会社名
        bill_company_name: { type: "text", placeholder: "株式会社ネオジャパン", value: "", label_class: elective_label_class, error_msg_list: [] },
        // 会社名・組織名(かな)
        bill_company_kana: { type: "text", placeholder: "かぶしきがいしゃねおじゃぱん", value: "", label_class: elective_label_class, error_msg_list: [] },
        // 部署名
        bill_department: { type: "text", placeholder: "営業部", value: "", label_class: elective_label_class, error_msg_list: [] },
        // 担当者名
        bill_president_name: { type: "text", placeholder: "山田　太郎", value: "", label_class: elective_label_class, error_msg_list: [] },
        // 担当者名(かな)
        bill_president_kana: { type: "text", placeholder: "やまだ　たろう", value: "", label_class: elective_label_class, error_msg_list: [] },
        // 郵便番号
        bill_postal_code: { type: "text", placeholder: "2208110（半角数字）", value: "", form_class: "number-form", label_class: elective_label_class, error_msg_list: [] },
        // 住所
        bill_address: { type: "", label_class: none_label_class },
        // 都道府県
        bill_prefecture: { type: "text", placeholder: "神奈川県", value: "", form_class: "w-50", label_class: elective_label_class, error_msg_list: [] },
        // 市区町村
        bill_city: { type: "text", placeholder: "横浜市西区", value: "", form_class: "w-50", label_class: elective_label_class, error_msg_list: [] },
        // 丁目番地
        bill_address1: { type: "text", placeholder: "みなとみらい二丁目2-1", value: "", form_class: "w-75", label_class: elective_label_class, error_msg_list: [] },
        // 建物名以下
        bill_address2: { type: "text", placeholder: "", value: "", form_class: "w-75", label_class: elective_label_class, error_msg_list: [] },
        // 電話番号
        bill_phone_number: { type: "text", placeholder: "045-123-1234（半角数字）", value: "", form_class: "number-form", label_class: elective_label_class, error_msg_list: [] },
        // FAX番号
        bill_fax_number: { type: "text", placeholder: "045-123-1234（半角数字）", value: "", form_class: "number-form", label_class: elective_label_class, error_msg_list: [] },
        // E-mail
        bill_e_mail: { type: "text", placeholder: "someone@example.com", value: "", label_class: elective_label_class, error_msg_list: [] },
        // E-mail(確認用)
        re_bill_e_mail: { type: "text", placeholder: "確認のためにもう一度入力してください", value: "", label_class: elective_label_class, error_msg_list: [] },

        // パスワード
        password: { type: "password", placeholder: "6文字以上・半角英数字記号", value: "", form_class: "password-form", label_class: require_label_class, error_msg_list: [] },
        re_password: { type: "password", placeholder: "確認のためにもう一度入力してください", value: "", form_class: "password-form", label_class: require_label_class, error_msg_list: [] },
      },

      company_list: [],
      notFoundMessage: { name:'（該当なし）', office: '一覧に該当する社名がない場合は、会社名を入力欄にご記入ください。', address: '' },
      // 都道府県
      prefectures: this.getPrefectureList(),

      // 住所取得エラーメッセージ
      get_address_error: "",
      // (請求書宛名情報)住所取得エラーメッセージ
      get_send_address_error: "",

      // エラー時のスクロール先
      error_scroll_position: 99,
    }
  },
  methods: {
    toggleSendInvoice() {
      this.SendInvoiceIsOpen = !this.SendInvoiceIsOpen;
    },
    inputCheck() {
      // 次へボタンをロックする
      this.isLoading = true;

      // エラー時のスクロール先をリセット
      this.error_scroll_position = 99;

      const vueData = this;

      // 入力必須項目
      let arRequestData  = {
        company_name: vueData.value.company_name,
        foreign_company_flg: vueData.value.foreign_company_flg,
        company_kana: vueData.value.company_kana,
        lbc_office_code: vueData.value.lbc_office_code,
        president_name: vueData.value.president_name,
        president_kana: vueData.value.president_kana,
        department: vueData.value.department,
        person_name: vueData.value.person_name,
        person_kana: vueData.value.person_kana,
        postal_code: vueData.value.postal_code,
        prefecture: vueData.value.prefecture,
        city: vueData.value.city,
        address1: vueData.value.address1,
        address2: vueData.value.address2,
        phone_number: vueData.value.phone_number,
        fax_number: vueData.value.fax_number,
        e_mail: vueData.value.e_mail,
        contract_type: vueData.value.contract_type,
        payment_method: vueData.value.payment_method,
        password: vueData.value.password,
        re_password: vueData.value.re_password,
        token: vueData.value.token,
      };

      // 請求書宛名情報のチェックがある場合、請求書宛名情報のパラメータも追加する
      if (vueData.value.send_invoice === true) {
        arRequestData['bill_company_name'] = vueData.value.bill_company_name
        arRequestData['bill_company_kana'] = vueData.value.bill_company_kana
        arRequestData['bill_department'] = vueData.value.bill_department
        arRequestData['bill_president_name'] = vueData.value.bill_president_name
        arRequestData['bill_president_kana'] = vueData.value.bill_president_kana
        arRequestData['bill_postal_code'] = vueData.value.bill_postal_code
        arRequestData['bill_prefecture'] = vueData.value.bill_prefecture
        arRequestData['bill_city'] = vueData.value.bill_city
        arRequestData['bill_address1'] = vueData.value.bill_address1
        arRequestData['bill_address2'] = vueData.value.bill_address2
        arRequestData['bill_phone_number'] = vueData.value.bill_phone_number
        arRequestData['bill_fax_number'] = vueData.value.bill_fax_number
        arRequestData['bill_e_mail'] = vueData.value.bill_e_mail
        arRequestData['re_bill_e_mail'] = vueData.value.re_bill_e_mail
      }

      // 入力チェック呼び出し
      F201FirstOrderRepository.getCustomerDetailCheck(arRequestData)
      // 入力チェック成功
      .then(() => {
        // 申し込み内容確認画面に移動
        this.$router.push({
          name: "ConfirmFirstOrder",
          query: {
            token: this.value.token
          }
        })
      })
      // 入力チェックエラー
      .catch((error) => {
        // 次へボタンをロックを解除する
        this.isLoading = false;

        // 共通のエラー処理
        this.apiError(error, '入力チェック処理', 'FirstOrder')

        // 仮申込関連のエラーの場合
        if (error.response.status === 404) {
          this.$router.push({
            name: "RelatedTmpOrder",
            params: {
              // 仮申込のエラーメッセージは一つなので添字決め打ち
              error_msg: error.response.data.error_list[0].error_msg
            }
          })
        }

        // 既存のエラーメッセージをリセット
        vueData.data.company_name.error_msg_list = [];
        vueData.data.company_kana.error_msg_list = [];
        vueData.data.president_name.error_msg_list = [];
        vueData.data.president_kana.error_msg_list = [];
        vueData.data.department.error_msg_list = [];
        vueData.data.person_name.error_msg_list = [];
        vueData.data.person_kana.error_msg_list = [];
        vueData.data.postal_code.error_msg_list = [];
        vueData.data.prefecture.error_msg_list = [];
        vueData.data.city.error_msg_list = [];
        vueData.data.address1.error_msg_list = [];
        vueData.data.address2.error_msg_list = [];
        vueData.data.phone_number.error_msg_list = [];
        vueData.data.fax_number.error_msg_list = [];
        vueData.data.contract_type.error_msg_list = [];
        vueData.data.payment_method.error_msg_list = [];
        vueData.data.bill_company_name.error_msg_list = [];
        vueData.data.bill_company_kana.error_msg_list = [];
        vueData.data.bill_department.error_msg_list = [];
        vueData.data.bill_president_name.error_msg_list = [];
        vueData.data.bill_president_kana.error_msg_list = [];
        vueData.data.bill_postal_code.error_msg_list = [];
        vueData.data.bill_prefecture.error_msg_list = [];
        vueData.data.bill_city.error_msg_list = [];
        vueData.data.bill_address1.error_msg_list = [];
        vueData.data.bill_address2.error_msg_list = [];
        vueData.data.bill_phone_number.error_msg_list = [];
        vueData.data.bill_fax_number.error_msg_list = [];
        vueData.data.bill_e_mail.error_msg_list = [];
        vueData.data.re_bill_e_mail.error_msg_list = [];
        vueData.data.password.error_msg_list = [];
        vueData.data.re_password.error_msg_list = [];

        // エラーリストの読み込み
        const arErrorList =  error.response.data.error_list;

        // 各エラーメッセージを画面に埋め込む
        for (let i = arErrorList.length - 1; i >= 0; i--) {
          switch (arErrorList[i].target){
            // ご契約者情報
            // 会社名・組織名
            case "company_name":
              vueData.data.company_name.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 1 ? 1 : this.error_scroll_position;
              break
            // 会社名・組織名(かな)
            case "company_kana":
              vueData.data.company_kana.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 1 ? 1: this.error_scroll_position
              break
            // 代表者名
            case "president_name":
              vueData.data.president_name.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 1 ? 1: this.error_scroll_position
              break
            // 代表者名(かな)
            case "president_kana":
              vueData.data.president_kana.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 1 ? 1: this.error_scroll_position
              break
            // 部署名
            case "department":
              vueData.data.department.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 1 ? 1: this.error_scroll_position
              break
            // 担当者名
            case "person_name":
              vueData.data.person_name.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 1 ? 1: this.error_scroll_position
              break
            // 担当者名(かな)
            case "person_kana":
              vueData.data.person_kana.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 1 ? 1: this.error_scroll_position
              break
            // 郵便番号
            case "postal_code":
              vueData.data.postal_code.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 1 ? 1: this.error_scroll_position
              break
            // 住所(都道府県)
            case "prefecture":
              vueData.data.prefecture.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 1 ? 1: this.error_scroll_position
              break
            // 住所(市区町村)
            case "city":
              vueData.data.city.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 1 ? 1: this.error_scroll_position
              break
            // 住所(丁目番地)
            case "address1":
              vueData.data.address1.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 1 ? 1: this.error_scroll_position
              break
            // 住所(建物名以下)
            case "address2":
              vueData.data.address2.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 1 ? 1: this.error_scroll_position
              break
            // 電話番号
            case "phone_number":
              vueData.data.phone_number.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 1 ? 1: this.error_scroll_position
              break
            // FAX番号
            case "fax_number":
              vueData.data.fax_number.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 1 ? 1: this.error_scroll_position
              break
            // ご契約種別
            case "contract_type":
              vueData.data.contract_type.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 2 ? 2: this.error_scroll_position
              break
            // お支払い方法
            case "payment_method":
              vueData.data.payment_method.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 2 ? 2: this.error_scroll_position
              break
            // 請求書宛名情報
            // 会社名・組織名
            case "bill_company_name":
              vueData.data.bill_company_name.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 3 ? 3: this.error_scroll_position
              break
            // 会社名・組織名(かな)
            case "bill_company_kana":
              vueData.data.bill_company_kana.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 3 ? 3: this.error_scroll_position
              break
            // 部署名
            case "bill_department":
              vueData.data.bill_department.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 3 ? 3: this.error_scroll_position
              break
            // 担当者名
            case "bill_president_name":
              vueData.data.bill_president_name.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 3 ? 3: this.error_scroll_position
              break
            // 担当者名(かな)
            case "bill_president_kana":
              vueData.data.bill_president_kana.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 3 ? 3: this.error_scroll_position
              break
            // 郵便番号
            case "bill_postal_code":
              vueData.data.bill_postal_code.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 3 ? 3: this.error_scroll_position
              break
            // 住所(都道府県)
            case "bill_prefecture":
              vueData.data.bill_prefecture.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 3 ? 3: this.error_scroll_position
              break
            // 住所(市区町村)
            case "bill_city":
              vueData.data.bill_city.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 3 ? 3: this.error_scroll_position
              break
            // 住所(丁目番地)
            case "bill_address1":
              vueData.data.bill_address1.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 3 ? 3: this.error_scroll_position
              break
            // 住所(建物名以下)
            case "bill_address2":
              vueData.data.bill_address2.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 3 ? 3: this.error_scroll_position
              break
            // 電話番号
            case "bill_phone_number":
              vueData.data.bill_phone_number.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 3 ? 3: this.error_scroll_position
              break
            // FAX番号
            case "bill_fax_number":
              vueData.data.bill_fax_number.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 3 ? 3: this.error_scroll_position
              break
            // E-mail
            case "bill_e_mail":
              vueData.data.bill_e_mail.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 3 ? 3: this.error_scroll_position
              break
            // E-mail(確認用)
            case "re_bill_e_mail":
              vueData.data.re_bill_e_mail.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 3 ? 3: this.error_scroll_position
              break
            // パスワード
            case "password":
              vueData.data.password.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 4 ? 4: this.error_scroll_position
              break
            // パスワード(確認用)
            case "re_password":
              vueData.data.re_password.error_msg_list.push(arErrorList[i].error_msg)
              this.error_scroll_position = this.error_scroll_position > 4 ? 4: this.error_scroll_position
              break
            default:
              // スクロール先を画面一番上に設定
              this.error_scroll_position = 99;
              break;
          }
        }

        // エラー箇所までスクロールする
        this.scrollErrorPosition();
      })
    },
    /**
     * エラーの箇所までスクロールさせる
     */
    scrollErrorPosition() {
      // アンカー
      let anchor = "";

      // スクロール箇所毎にアンカーの値を設定
      switch (this.error_scroll_position) {
        // ご契約者情報
        case 1:
          anchor = "customer-info";
          break;
        // ご契約種別・お支払い方法
        case 2:
          anchor = "contract-type";
          break;
        // 請求書宛名情報
        case 3:
          anchor = "send-invoice";
          break;
        // パスワード
        case 4:
          anchor = "password";
          break;
      }

      // アンカーが設定されている場合
      if (anchor !== "") {
        // アンカーの場所までスクロール
        document.getElementById(anchor).scrollIntoView();
      }
      // アンカーが設定されてない
      else {
        // 画面の一番上へ
        this.pageTopScroll();
      }
    },
    // 会社名候補一覧の取得
    getCompanyInfo () {
      // リクエストパラメータ
      const arParam = {
        cmd: 'search', // コマンド
        s: this.value.prefecture + ' ' + this.value.company_name // 検索キーワード
      }

      // 会社名候補一覧の初期化
      this.company_list = []
      // LBC企業管理コードの初期化
      this.value.lbc_office_code = ''

      // ローディング開始
      this.isCompanyListLoading = true

      // リクエスト送信
      LbcCode.get(arParam)
        // API呼び出し成功時
        .then((response) => {
          // 各会社名候補の情報を保存していく
          for (let index in response.data.list) {
            this.company_list.push({
              name: response.data.list[index].lbc_company_name,
              office: response.data.list[index].lbc_office_name,
              address: response.data.list[index].lbc_company_addr,
              lbc_office_code: response.data.list[index].lbc_office_id
            })
          }

          // 会社名候補が0件の場合
          if (this.company_list.length === 0) {
            // 会社名候補一覧を非表示
            this.bShowCompanyNameList = false;
          }
          else {
            // 会社名候補一覧を表示
            this.bShowCompanyNameList = true
          }
        })
        // 失敗時
        .catch(() => {
          // 会社名候補一覧を非表示
          this.bShowCompanyNameList = false;
        })
        .finally(()=> {
          // 該当する会社名がないメッセージを追加する
          this.company_list.push(this.notFoundMessage)
          // ローディング終了
          this.isCompanyListLoading = false
        })
    },
    // 会社名候補一覧の表示・非表示の切り替え
    updateCompanyNameSearch() {
      // タイマーをリセットして実行待ちのタイマーをクリアする
      clearTimeout(this.timer);
      // 会社名・組織名を入力後1秒後に実行する
      this.timer = setTimeout(() => {
        // 都道府県が選択されている かつ 会社名・組織名が２文字以上入力されている場合
        if (this.value.prefecture !== '' && this.value.company_name.length > 1) {
          // 会社名候補一覧取得
          this.getCompanyInfo()
        }
        else {
          // 会社名候補一覧を非表示
          this.bShowCompanyNameList = false
        }
      }, 1000);
    },
    // 選択した会社名候補を保存する
    setCompanyName(company) {
      // 会社名候補一覧を非表示
      this.bShowCompanyNameList = false

      // 選択された会社名が「（該当なし）」でない場合
      if (company.name !== '（該当なし）') {
        // 選択した会社名を設定する
        this.value.company_name = company.name
      }
      // 選択された会社のLBC企業管理コードを設定する
      this.value.lbc_office_code = company.lbc_office_code
    },
  }
}
</script>

<style scoped>
::v-deep .none-label {
  padding-right: 53px !important;
}
.mail-text {
  font-size: 1rem;
  margin-top: 1px;
  word-break: break-all;
}
.number-form {
  width: 185px;
}

.password-form {
  width: 270px;
}
</style>
